/**
 * Created by shobhitjain on 31/12/19.
 */

import React from 'react';
import style from './index.scss';
import classnames from 'classnames';

/**
 * This is a Table component
 * @param props {isStriped} for making tables striped
 * @returns {*}
 * @constructor
 */
const Table = (props) => {
  const { isStriped, enableOverflowScroll, isFixedColumn } = props;
  return (
    <table
      className={classnames(
        isFixedColumn && style.table_tookitaki_fixed_column,
        enableOverflowScroll
          ? style.table_tookitaki_w_overflow
          : style.table_tookitaki,
        isStriped ? style.table_striped : '',
        props.class
      )}>
      {props.children}
    </table>
  );
};

export default Table;
